import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";

const scrollTo = (target) => (e) => {
  e.preventDefault();
  window.__lenis?.scrollTo(target, { offset: -72 });
};

const links = [
  { label: "Prensipler", href: "#prensipler", testid: "nav-projects-link" },
  { label: "Hizmetler", href: "#hizmetler", testid: "nav-services-link" },
  { label: "Başvuru", href: "#basvuru", testid: "nav-process-link" },
];

const Navbar = () => (
  <motion.header
    initial={{ y: -64, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    className="fixed top-0 inset-x-0 z-50 border-b border-white/[0.06] bg-[#08070D]/75 backdrop-blur-xl"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-16 h-[72px] flex items-center justify-between">
      <a
        href="#top"
        onClick={scrollTo(0)}
        data-testid="nav-logo"
        className="font-display font-extrabold text-xl tracking-tight"
      >
        BEFORA<span className="text-[#10B981]">.</span>
      </a>

      <nav className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={scrollTo(l.href)}
            data-testid={l.testid}
            className="text-sm text-[#9CA3AF] hover:text-white transition-colors duration-300"
          >
            {l.label}
          </a>
        ))}
      </nav>

      <div className="flex items-center gap-3">
        <Link
          to="/admin"
          data-testid="nav-admin-login-button"
          className="hidden sm:flex items-center gap-1.5 text-sm text-[#6B7280] hover:text-white transition-colors duration-300 px-3 py-2"
        >
          <Lock size={14} />
          Yönetici
        </Link>
        <button
          onClick={scrollTo("#basvuru")}
          data-testid="nav-apply-button"
          className="flex items-center gap-1.5 bg-[#10B981] hover:bg-[#0ea371] text-[#08070D] text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
        >
          Proje Başvurusu
          <ArrowUpRight size={15} />
        </button>
      </div>
    </div>
  </motion.header>
);

export default Navbar;
